<template>
  <div class="container-fluid">
    <company-object-sidebar
      object-type="Measure Group"
      :company-objects="measureGroups"
      :value="selectedMeasureGroup?.key"
      @input="selectMeasureGroup" />
    <div class="mr-6">
      <h2 class="mb-3">
        Measure Groups
      </h2>
      <div class="editor">
        <div class="actions">
          <button
            :disabled="!dirty"
            @click="reset">
            Reset
          </button>
          <button
            :disabled="!dirty"
            @click="save">
            Save
          </button>
          <select
            v-model="selectedVersion"
            :disabled="!selectedGroupVersions">
            <option
              value=""
              disabled>
              History
            </option>
            <option
              v-for="version in selectedGroupVersions"
              :key="version.id"
              :value="version">
              {{ version.label }}
            </option>
          </select>
        </div>
        <schema-form
          v-if="selectedMeasureGroup"
          v-model="selectedMeasureGroupModel"
          :schema="schemas[testType]"
          :errors="errors"
          :all-schemas="schemas" />
      </div>
    </div>
  </div>
</template>

<script>
  import SchemaForm from '@/views/internal/schema_form/SchemaForm.vue'
  import CompanyObjectSidebar from '@/components/reports/config/common/CompanyObjectSidebar.vue'

  export default {
    name: 'MeasureGroups',
    components: {
      SchemaForm,
      CompanyObjectSidebar,
    },
    provide () {
      return {
        allSchemas: this.schemas,
      }
    },
    data () {
      return {
        schemas: null,
        dirty: false,
        testType: 'exporters__snap__schema__content__measure__measure_group__MeasureGroup',
        measureGroups: [],
        errors: [],
        selectedMeasureGroup: null,
        selectedGroupVersions: null,
      }
    },
    computed: {
      selectedVersion: {
        get () {
          return ''
        },
        set (version) {
          this.selectedMeasureGroup = structuredClone(version.config)
          this.dirty = true
        },
      },
      selectedMeasureGroupModel: {
        get () {
          return this.selectedMeasureGroup
        },
        set (value) {
          this.dirty = true
          this.selectedMeasureGroup = value
        },
      },
    },
    mounted () {
      this.loadApiSchemas()
      this.loadMeasureGroups()
    },
    methods: {
      reset () {
        this.errors = []
        this.selectMeasureGroup(this.selectedMeasureGroup.key)
      },
      async save () {
        let saveAttempt = await this.$apis.companyConfigs.content.measureGroups.set(this.selectedMeasureGroup)
        if (!saveAttempt.success) {
          this.errors = saveAttempt.errors.errors
        } else {
          await this.loadMeasureGroups()
          this.reset()
        }
      },
      async selectMeasureGroup (measureGroup) {
        this.selectedMeasureGroup = structuredClone(this.measureGroups.find(group => group.key == measureGroup))
        this.loadVersions()
        this.dirty = false
      },
      async loadApiSchemas () {
        this.schemas = (await this.$apis.app.getExporterApiSpec()).components.schemas
      },
      async loadVersions () {
        let key = this.selectedMeasureGroup.key
        this.selectedGroupVersions = []
        let response = await this.$apis.companyConfigs.content.measureGroups.versions(key)
        if (key == this.selectedMeasureGroup.key) {
          this.selectedGroupVersions = response
        }
      },
      async loadMeasureGroups () {
        this.measureGroups = await this.$apis.companyConfigs.content.measureGroups.list()
      },
    },
  }
</script>

<style lang="scss" scoped>
.container-fluid {
  background: #F5F5F5;
  width: 100%;
  min-height: 1000px;
  display: flex;
  flex-direction: row;

  h2 {
    font-size: 17px;
  }

}
</style>
